import {useFormikContext} from 'formik'
import {FC} from 'react'

import {BusinessInfoForm} from '@/components/form/BusinessInfoForm'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'

import {TrademarkVerificationFields} from '../types'

export const TrademarkServiceDescription: FC<React.PropsWithChildren<unknown>> = () => {
  const {values, errors, touched} = useFormikContext<TrademarkVerificationFields>()
  const {descriptionNew} = useTrademarkVerificationContent().serviceDescription

  const isVisible = values.type === 'image' && !values.file ? false : true
  const hasWebsiteError = !!errors.client_website && !!touched.client_website

  return (
    <BusinessInfoForm
      isAnimated={values.type === 'image'}
      animationStarted={isVisible}
      hasWebsiteError={hasWebsiteError}
      newDescriptionKey={descriptionNew}
    />
  )
}
